import React, { useState, useCallback } from "react";
import Modal from "react-modal";
import "./css/Modais.css";
import "./css/ModaisMobile.css";
import "./css/Images.css";
import { styled } from "@mui/system";
import errorIcon from "../Toast/Image/error.svg";

import ButtonX from "../Images/ButtonX.svg";
import checkIcon from "../Toast/Image/check.svg";
import Toast from "../Toast/Toast";
import { useProgress } from "../../hooks/progress";
import api from "../../services/api/index";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Box,
  TextField
} from "@mui/material";

export default function ModalLink({
  isOpen,
  onRequestClose,
  id
}) {

  const { setLoad } = useProgress();

  const [list, setList] = useState([]);
  const [feedback, setFeedback] = useState("");
  const [isClose] = useState(false);

    const handleExit = useCallback(() => {
          onRequestClose();
    },[onRequestClose]);


  const showToast = useCallback(
    async (type) => {
      const id = Math.floor(Math.random() * 101 + 1);
      let toastProperties = {
        id,
        title: "",
        description: "",
        backgroundColor: "",
        icon: checkIcon,
      };

      switch (type) {
        case "201":
          toastProperties.description = "Feedback salvo";
          toastProperties.backgroundColor = "#5cb85c";
          break;
        case "200":
          toastProperties.description = "Já existe um compromisso para este horário";
          toastProperties.backgroundColor = "#f0ad4e";
          toastProperties.icon = errorIcon;
          break;
        case "200Exclude":
            toastProperties.description = "Compromisso excluido";
            toastProperties.backgroundColor = "#f0ad4e";
            toastProperties.icon = errorIcon;
            break;
        case "ErroExclude":
            toastProperties.description = "Falha ao excluir";
            toastProperties.backgroundColor = "#f0ad4e";
            toastProperties.icon = errorIcon;
          break;
        case "400":
          toastProperties.description = "Campos inválidos! Verifique os dados informados.";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        case "403":
          toastProperties.description = "Acesso não autorizado";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        case "500":
          toastProperties.description = "Erro interno do servidor. Tente novamente";
          toastProperties.backgroundColor = "#d9534f";
          toastProperties.icon = errorIcon;
          break;
        default:
          return;
      }

      setList((prev) => [...prev, toastProperties]);

      // Aguarda 1 segundo antes de fechar o modal caso seja um sucesso (201)
      if (type === "201") {
        setTimeout(() => {
          onRequestClose();
        }, 1000);
      }
    },
    [onRequestClose]
  );

  const StyledCancelButton = styled(Button)({
    border: "1px solid #6C5AF4",
    borderRadius:'8px',
    color: "#6C5AF4",
    backgroundColor: "white",
    textTransform: "none",
    '&:hover': {
      backgroundColor: "#ECE8FD",
    },
  });
  
  const StyledConfirmButton = styled(Button)({
    backgroundColor: "#6C5AF4",
    color: "white",
    borderRadius:'8px',
    textTransform: "none",
    '&:hover': {
      backgroundColor: "#5A47C4",
    },
  });

  const handleSave = async () => {
    if (!id) return;
  
    try {
      setLoad(true);
      api.defaults.headers.common = {
        Authorization: `bearer ${sessionStorage.getItem("@ARP-Energia:token")}`,
      };
  
      const response = await api.post(
        `/csp/representante/compromissos/feedback/criar/${id}`,
        { descricao: feedback }
      );
  
      if (response.status === 201) {
        showToast("201");
        setTimeout(() => {
          handleExit(); // Fechar modal após sucesso
        }, 1000);
      } else {
        showToast("400");
      }
    } catch (error) {
      if (error.response) {
        await showToast(error.response.status.toString());
      } else {
        await showToast("500");
      }
    } finally {
      setTimeout(() => {
        setLoad(false);
      }, 1000);
    }
  };

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <Modal
        isOpen={isOpen}
        onRequestClose={() => {
          if (isClose === true) {
            onRequestClose();
          }
        }}
        contentLabel="Modal"
        style={{ outline: 0 }}
        ariaHideApp={false}
        className={{
          base: "modal-base",
          afterOpen: "modal-base_after-open",
          beforeClose: "modal-base_before-close",
        }}
        overlayClassName={{
          base: "overlay-base",
          afterOpen: "overlay-base_after-open",
          beforeClose: "overlay-base_before-close",
        }}
        shouldCloseOnOverlayClick={true}
      >
        <div className="imgX" id="btnXModalGPCR" onClick={onRequestClose}>
          <img alt={""} src={ButtonX}></img>
        </div>
      
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <DialogTitle sx={{ margin: "0 auto" }}>Feedback do compromisso</DialogTitle>
        </Box>
        <DialogContent>
          <TextField
            fullWidth
            multiline
            minRows={4}
            variant="outlined"
            placeholder="Feedback do compromisso"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: "#6C5AF4" },
                '&.Mui-focused fieldset': { borderColor: "#6C5AF4" },
              },
              borderRadius: "8px"
            }}
          />
          <DialogContentText sx={{ marginTop: "10px", font:'8px' }}>
            Seus feedbacks salvos serão exibidos em: <span style={{ fontStyle: "italic" }}>Detalhes do compromisso.</span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <StyledCancelButton onClick={handleExit}>Voltar</StyledCancelButton>
          <StyledConfirmButton onClick={handleSave}>Salvar</StyledConfirmButton>
        </DialogActions>
      </Modal>
    </>
  );
}